<div class="mb-4">
	<lgb-message [(error)]="error" [(msg)]="msg"></lgb-message>
</div>
<div class="mb-4">
	<lgb-console maxHeight="75vh" [logs]="fullLogs()"></lgb-console>
</div>


@if(payloads().length>0){
	<p class="element-info mb-2">
		<i class="text-primary fa-light fa-arrow-rotate-right"></i> Relancer l'étape selectionnée<br/>
		<i class="text-primary fa-light fa-arrows-retweet"></i> Relancer l'étape seléctionné et les suivantes
	</p>
	<ul class="list bg-base-100 rounded-box shadow-md">
	  <li class="p-4 pb-2 text-xs opacity-60 tracking-wide">Etapes de génération des indexes</li>
	  
		@for(payload of payloads(); track payload){
		  <li class="list-row">
	  	    <div class="text-4xl font-thin opacity-30 tabular-nums">{{((payload.index<9)? '0' : '')}}{{payload.index+1}}</div>
		    <div>
		      <div>{{payload.titre}}</div>
		      <span class="badge badge badge-soft badge-sm text-xs font-semibold opacity-60" [ngClass]="getClassState(payload)">{{((payload.state=='Valide')? 'Terminée' : payload.state)}}</span>
		    </div>
		    <button (click)="replay(payload.index)" class="btn btn-square btn-ghost" [disabled]="loading()">
		      <i class="fa-regular fa-arrow-rotate-right"></i>
		    </button>
		    <button (click)="replayLoop(payload.index)" class="btn btn-square btn-ghost" [disabled]="loading()">
		      <i class="fa-regular fa-arrows-retweet"></i>
		    </button>
		  </li>
		}
	</ul>
}

<button (click)="start()" class="btn btn-primary btn-gradient w-full mt-4">
	Generer
</button>